// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2YSBB","header":"PatientBlock_header__19q2q","label":"PatientBlock_label__3gfnO","option":"PatientBlock_option__1T-zQ"};